import { RequestDateChangeTableProps } from "./request-date-change-table.types";
import { RequestDateChangeTableView } from "./request-date-change-table-view";
import { useRequestDateChangeTable } from "./use-request-date-change-table";

export const RequestDateChangeTable = ({
  tradeContractId,
  refetchTradeContract,
  ...rest
}: RequestDateChangeTableProps) => {
  const logic = useRequestDateChangeTable({ tradeContractId, refetchTradeContract });
  return <RequestDateChangeTableView {...logic} {...rest} />;
};
